import { render } from "./DropshipPolicyText.vue?vue&type=template&id=2a2b6580"
const script = {}

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__